import {defineStore} from 'pinia';
import {ref, useRequestURL, computed} from '#imports';
import {readonlyState} from '@malt/utils';

export enum UrlAction {
    PhoneNumberMissing = 'PHONE_NUMBER_MISSING',
    PhoneNumberMissingAndNeedValidation = 'PHONE_NUMBER_MISSING_AND_NEED_VALIDATION',
    PhoneNumberNeedValidation = 'PHONE_NUMBER_NEED_VALIDATION',
}

export const useRedirectParamsStore = defineStore('redirect-params-store', () => {
    const dropRedirect = ref<string | null>();
    const successRedirect = ref<string | null>();
    const source = ref<string | null>();
    const action = ref<UrlAction>();
    const defaultRedirect = `/account/phone`;
    const defaultPageSource = 'client_settings';

    function setRedirectUrl() {
        const currentUrl = useRequestURL();
        const dropRedirectPath = currentUrl.searchParams.get('dropRedirectPath');
        const successRedirectPath = currentUrl.searchParams.get('successRedirectPath');
        const actionQuery = currentUrl.searchParams.get('action') as UrlAction;
        const pageSource = currentUrl.searchParams.get('pageSource');

        dropRedirect.value = dropRedirectPath || defaultRedirect;
        successRedirect.value = successRedirectPath || defaultRedirect;
        action.value = actionQuery;
        source.value = pageSource || defaultPageSource;
    }

    const redirectParams = computed(() => ({
        ...(dropRedirect.value ? {dropRedirectPath: dropRedirect.value} : {}),
        ...(successRedirect.value ? {successRedirectPath: successRedirect.value} : {}),
        ...(source.value ? {pageSource: source.value} : {}),
    }));

    const isInAccountSettings = computed(() => {
        return dropRedirect.value === defaultRedirect && successRedirect.value === defaultRedirect;
    });

    const successRedirectUrl = computed(() => (isInAccountSettings.value ? `/phone?phone=verified` : successRedirect.value));

    return {
        dropRedirect: readonlyState(dropRedirect),
        successRedirect: readonlyState(successRedirect),
        action: readonlyState(action),
        source: readonlyState(source),
        isInAccountSettings,
        successRedirectUrl,
        redirectParams,
        setRedirectUrl,
    };
});
